import { all } from 'redux-saga/effects';
import { assetSaga } from './services/controllers/asset/AssetSaga';
import { bookSaga } from './services/controllers/book/BookSaga';
import { imageSaga } from './services/controllers/image/ImageSaga';
import { userSaga } from './services/controllers/user/UserSaga';

export default function* rootSaga() {
  yield all([userSaga(), bookSaga(), imageSaga(), assetSaga()]);
}
